(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-landing-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('superment-hero-gallery')) {
  customElements.define('superment-hero-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.thumbs = [...this.querySelectorAll('[data-thumb]')];
      this.toggle = this.querySelector('[data-toggle]');
      this.status = this.querySelector('[data-status]');
      this.index = 0;
      this.request = 0;
      this.hovered = false;
      this.visible = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.running = this.dataset.autoplay === 'true' && !this.motion.matches && this.dataset.editor !== 'true';
      if (this.slides.length < 2) return;
      this.querySelector('[data-controls]').hidden = false;
      this.updateToggle();
      this.thumbs.forEach((button, index) => {
        button.addEventListener('click', () => { this.stop(); this.show(index, true); }, { signal });
      });
      this.addEventListener('focusin', () => this.stop(), { signal });
      this.addEventListener('mouseenter', () => { this.hovered = true; this.clear(); }, { signal });
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, { signal });
      if (this.toggle) {
        this.toggle.addEventListener('pointerdown', () => { this.toggleWasRunning = this.running; }, { signal });
        this.toggle.addEventListener('click', () => {
          this.running = !(this.toggleWasRunning ?? this.running);
          this.toggleWasRunning = undefined;
          this.updateToggle();
          this.schedule();
        }, { signal });
      }
      const stage = this.querySelector('[data-stage]');
      stage.addEventListener('click', () => this.stop(), { signal });
      stage.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'touch' || !event.isPrimary) return;
        this.stop();
        this.touch = { x: event.clientX, y: event.clientY, id: event.pointerId };
        stage.setPointerCapture(event.pointerId);
      }, { signal });
      stage.addEventListener('pointerup', (event) => {
        if (!this.touch || this.touch.id !== event.pointerId) return;
        const dx = event.clientX - this.touch.x;
        const dy = event.clientY - this.touch.y;
        this.touch = null;
        if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.3) this.show(this.index + (dx < 0 ? 1 : -1), true);
      }, { signal });
      stage.addEventListener('pointercancel', () => { this.touch = null; }, { signal });
      document.addEventListener('visibilitychange', () => this.schedule(), { signal });
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.stop(); }, { signal });
      document.addEventListener('shopify:block:select', (event) => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) { this.stop(); this.show(index, true); }
      }, { signal });
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.schedule();
      }, { threshold: 0.15 });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.clear();
      this.request++;
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
    clear() { clearTimeout(this.timer); }
    stop() { this.running = false; this.request++; this.clear(); this.updateToggle(); }
    updateToggle() {
      if (!this.toggle) return;
      this.toggle.setAttribute('aria-label', this.running ? this.toggle.dataset.pause : this.toggle.dataset.play);
      this.toggle.querySelector('[data-pause-icon]').hidden = !this.running;
      this.toggle.querySelector('[data-play-icon]').hidden = this.running;
    }
    schedule() {
      this.clear();
      if (!this.running || this.hovered || !this.visible || document.hidden || this.slides.length < 2) return;
      this.timer = setTimeout(() => this.show(this.index + 1), Number(this.dataset.interval) || 5000);
    }
    async show(index, manual = false) {
      this.clear();
      const token = ++this.request;
      const next = (index + this.slides.length) % this.slides.length;
      const image = this.slides[next].querySelector('img');
      image.loading = 'eager';
      try { await image.decode(); } catch {
        if (token === this.request) this.stop();
        return;
      }
      if (!this.isConnected || token !== this.request) return;
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === next);
        slide.setAttribute('aria-hidden', String(i !== next));
        this.thumbs[i].setAttribute('aria-pressed', String(i === next));
      });
      this.index = next;
      const glass = this.querySelector('[data-hero-glass]');
      if (glass) glass.hidden = this.slides[next].dataset.original !== 'true';
      const button = this.thumbs[next];
      const row = button.parentElement;
      row.scrollTo({ left: button.offsetLeft - row.offsetLeft - (row.clientWidth - button.clientWidth) / 2, behavior: this.motion.matches ? 'instant' : 'smooth' });
      if (manual && this.status) this.status.textContent = button.getAttribute('aria-label');
      this.schedule();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-trust-bar"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('superment-trust-swipe')) {
  customElements.define('superment-trust-swipe', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.superment-trust-bar__track');
      this.hint = this.querySelector('.superment-trust-bar__swipe-hint');
      if (!this.track || !this.hint) return;
      this.mobile = matchMedia('(max-width: 749px)');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.animations = [];
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.stop = () => { this.played = true; this.animations.forEach(a => a.cancel()); this.animations = []; };
      this.update = () => {
        const mobile = this.mobile.matches;
        const remaining = this.track.scrollWidth - this.track.clientWidth - this.track.scrollLeft;
        this.hint.hidden = !mobile || remaining <= 2;
        this.track.tabIndex = mobile ? 0 : -1;
        if (!mobile) { this.animations.forEach(a => a.cancel()); this.track.scrollLeft = 0; }
        if (this.motion.matches) this.animations.forEach(a => a.cancel());
        if (mobile && this.visible && !this.played && !this.hint.hidden) {
          this.played = true;
          if (!this.motion.matches && this.track.scrollLeft <= 2) {
            this.animations = [...this.track.children].map(item => item.animate([
              { transform: 'translateX(0)' },
              { transform: 'translateX(-42px)', offset: .45 },
              { transform: 'translateX(0)' }
            ], { duration: 1100, iterations: 2, easing: 'cubic-bezier(.45, 0, .2, 1)' }));
            const arrow = this.hint.querySelector('.superment-trust-bar__swipe-arrow');
            if (arrow) this.animations.push(arrow.animate([
              { transform: 'translateX(0)' }, { transform: 'translateX(9px)' }, { transform: 'translateX(0)' }
            ], { duration: 550, iterations: 4, easing: 'ease-in-out' }));
          }
        }
      };
      ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach(type => this.track.addEventListener(type, this.stop, { passive: true, signal }));
      this.track.addEventListener('scroll', this.update, { passive: true, signal });
      this.mobile.addEventListener('change', this.update, { signal });
      this.motion.addEventListener('change', this.update, { signal });
      this.resize = new ResizeObserver(this.update);
      this.resize.observe(this.track);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries.some(entry => entry.isIntersecting);
        if (!this.visible) this.animations.forEach(a => a.cancel());
        this.update();
      }, { threshold: .5 });
      this.observer.observe(this);
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      this.observer?.disconnect();
      this.animations?.forEach(a => a.cancel());
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["superment-coa"] && !Shopify.designMode) return;
  try {
    
  if (!window.supermentCoaLightboxInstalled) {
    window.supermentCoaLightboxInstalled = true;
    let activeDialog = null;
    let trigger = null;
    let previousOverflow = '';
    const restore = (dialog) => {
      if (dialog !== activeDialog) return;
      document.documentElement.style.overflow = previousOverflow;
      activeDialog = null;
      if (trigger?.isConnected) trigger.focus({ preventScroll: true });
      trigger = null;
    };
    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-coa-open]');
      if (link) {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const section = link.closest('.sm-coa');
        const dialog = [...document.querySelectorAll('[data-coa-dialog]')].find(item => item.dataset.coaDialog === section?.id);
        if (!dialog || typeof dialog.showModal !== 'function') return;
        event.preventDefault();
        if (activeDialog) { const previous = activeDialog; previous.close(); restore(previous); }
        const image = dialog.querySelector('[data-coa-full]');
        image.alt = link.dataset.coaAlt || '';
        image.src = link.href;
        trigger = link;
        previousOverflow = document.documentElement.style.overflow;
        activeDialog = dialog;
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        dialog.addEventListener('close', () => restore(dialog), { once: true });
        return;
      }
      const closeButton = event.target.closest('[data-coa-close]');
      if (closeButton) { closeButton.closest('dialog').close(); return; }
      if (event.target === activeDialog) activeDialog.close();
    });
    document.addEventListener('shopify:section:unload', (event) => {
      if (activeDialog && event.target.contains(activeDialog)) {
        const dialog = activeDialog;
        dialog.close();
        restore(dialog);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
